import { Route, Routes } from 'react-router-dom';
import AppShell from './AppShell';
import { DebriefStub } from '@/screens/stubs';
import DashboardScreen from '@/screens/DashboardScreen';
import LearnScreen from '@/screens/LearnScreen';
import PracticeScreen from '@/screens/PracticeScreen';
import PlaybookScreen from '@/screens/PlaybookScreen';
import TeamScreen from '@/screens/TeamScreen';
import LessonScreen from '@/screens/LessonScreen';
import LiveLabScreen from '@/screens/LiveLabScreen';
import NotFoundScreen from '@/screens/NotFoundScreen';
import RoleplayScreen from '@/screens/RoleplayScreen';
import DebriefScreen from '@/screens/DebriefScreen';

/**
 * Phase A route map — the Comcast layout, with stub components on
 * every route except Roleplay and Debrief (which already work and
 * are wired to the live adapter).
 *
 * AppShell wraps Home / Learn / Practice / Live Lab / Playbook /
 * Team. Lesson, Roleplay, Debrief live outside the shell because
 * they ship their own top bars per the Comcast brief.
 *
 * Phase B replaces each stub with the ported Comcast screen,
 * insurance content swapped in.
 */
export default function AppRoutes() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/" element={<DashboardScreen />} />
        <Route path="/learn" element={<LearnScreen />} />
        <Route path="/practice" element={<PracticeScreen />} />
        <Route path="/live-lab" element={<LiveLabScreen />} />
        <Route path="/playbook" element={<PlaybookScreen />} />
        <Route path="/team" element={<TeamScreen />} />
      </Route>
      <Route path="/lesson/:lessonId" element={<LessonScreen />} />
      <Route path="/roleplay/:scenarioId" element={<RoleplayScreen />} />
      <Route path="/debrief/:sessionId" element={<DebriefScreen />} />
      {/* Legacy stub-only debrief route, in case anything links there
          without a sessionId. */}
      <Route path="/debrief" element={<DebriefStub />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
}
